import { content as homeInventoryContent } from "./posts/home-inventory";
import { content as recallsContent } from "./posts/recalls";
import { content as returnsContent } from "./posts/returns";
import { content as disasterContent } from "./posts/disaster";
import { content as acvRcvContent } from "./posts/acv-rcv";
import { content as homeInventoryAppsContent } from "./posts/home-inventory-apps";

export interface BlogPost {
  slug: string;
  title: string;
  description: string;
  date: string;
  dateModified?: string;
  readTime: string;
  category: string;
  content: string;
  heroImage?: string;
}

export const blogPosts: BlogPost[] = [
  {
    slug: "home-inventory-for-insurance",
    title: "How to Create a Home Inventory for Insurance Claims",
    description: "Most people can recall about 30-40% of what they owned after a total loss. The rest is money left on the table. Here's how to fix that.",
    date: "2026-04-07",
    readTime: "9 min read",
    category: "Insurance",
    content: homeInventoryContent,
  },
  {
    slug: "how-to-check-product-recalls",
    title: "How to Check if Your Products Have Been Recalled",
    description: "The CPSC issues about 6 recalls per week. In 2025, they hit an 18-year high. Here's how to find out if something in your house is on the list.",
    date: "2026-04-07",
    readTime: "9 min read",
    category: "Safety",
    content: recallsContent,
  },
  {
    slug: "return-policy-cheat-sheet",
    title: "Return Policy Cheat Sheet: Major Retailer Return Windows and Deadlines",
    description: "Every retailer has different windows, exceptions, and fees. Here's the comparison table, store-by-store breakdown, and the tricks most people miss.",
    date: "2026-04-07",
    readTime: "10 min read",
    category: "Returns",
    content: returnsContent,
  },
  {
    slug: "what-to-do-after-house-fire-burglary",
    title: "What to Do After a House Fire or Burglary: An Insurance Claim Checklist",
    description: "A step-by-step guide to the first 24 hours, working with adjusters, and getting a fair settlement. Plus the preparation step that changes everything.",
    date: "2026-04-07",
    readTime: "10 min read",
    category: "Insurance",
    content: disasterContent,
  },
  {
    slug: "acv-vs-rcv-insurance",
    title: "Home Insurance: ACV vs RCV -- What Your Claim Is Actually Worth",
    description: "The difference between these two numbers on your policy could cost you $12,000. Here's the math your insurer hopes you never run.",
    date: "2026-04-07",
    readTime: "10 min read",
    category: "Insurance",
    content: acvRcvContent,
  },
  {
    slug: "best-home-inventory-apps",
    title: "Best Home Inventory Apps Compared: An Honest Guide for 2026",
    description: "A side-by-side comparison of Manifest, Sortly, HomeZada, Nest Egg, Itemtopia, and spreadsheets. Features, pricing, and who each one is actually for.",
    date: "2026-04-07",
    readTime: "11 min read",
    category: "Guides",
    content: homeInventoryAppsContent,
  },
];

export function getBlogPost(slug: string): BlogPost | undefined {
  return blogPosts.find((p) => p.slug === slug);
}
